"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class OptinChallenge extends _react.default.Component {
  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  render() {
    const {
      data,
      onClick
    } = this.props;
    if (data) return /*#__PURE__*/_react.default.createElement("div", {
      className: 'd-flex justify-content-center align-items-center position-fixed',
      style: {
        height: '100vh',
        top: 0,
        left: 0,
        width: '100%',
        background: 'rgba(0,0,0,.85)'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row justify-content-center",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-12 col-md-9 col-lg-6"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card shadow",
      style: {
        width: '100%',
        maxHeight: '100vh'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-body"
    }, data.TitleDisplayText && /*#__PURE__*/_react.default.createElement("h1", {
      className: "card-title"
    }, data.TitleDisplayText), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-text"
    }, data.TitleDisplayText && /*#__PURE__*/_react.default.createElement("p", {
      className: 'text-muted'
    }, "Please first make sure you have read the ", data.TitleDisplayText, " and confirm it afterwards.")), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-text position-relative my-3",
      style: {
        maxHeight: '70vh',
        overflow: 'scroll'
      }
    }, data.TextDisplayText && (this.isJson(data.TextDisplayText) ? /*#__PURE__*/_react.default.createElement(_components.RichText, {
      value: data.TextDisplayText
    }) : /*#__PURE__*/_react.default.createElement("p", null, data.TextDisplayText))), /*#__PURE__*/_react.default.createElement("div", {
      className: 'd-flex justify-content-end'
    }, data.Optional && /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-secondary mr-4",
      onClick: () => onClick({
        OptInEntryId: data.Id,
        UserAccepted: false
      })
    }, "Skip"), /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-primary",
      onClick: () => onClick({
        OptInEntryId: data.Id,
        UserAccepted: true
      })
    }, "Accept")))))));
  }
}
var _default = exports.default = OptinChallenge;
module.exports = exports.default;